export default "__VITE_ASSET__K0hhfmyh__"